import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Copies à corriger")
], -1)
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement des copies à corriger...", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "text-center py-5 text-muted"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success mb-3 d-block" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Composition"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Étudiant"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Code session"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0" }, "Date soumission"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase fw-medium text-body-tertiary fs-13 pt-0 text-end pe-0" }, "Actions")
  ])
], -1)
const _hoisted_13 = { class: "fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "text-end pe-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil me-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_ctx.sessions.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" Aucune copie en attente de correction. ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, (session) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: session.resultatId
                    }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(session.compositionTitre), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(session.etudiant), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(session.sessionCode), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.formatDate(session.dateSoumission)), 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createVNode(_component_router_link, {
                          to: { name: 'CorrectionSessionPage', params: { sessionId: session.sessionId } },
                          class: "btn btn-primary btn-sm"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18,
                            _createTextVNode(" Corriger ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
    ])
  ]))
}